import WalletPicker from '@/components/WalletPicker.vue'
import { availableConnectors, connectWallet, hasWallet, isWalletConnected } from '@/web3'

// shared wallet connect flow for views
// views render <WalletPicker v-if="walletChoices.length" ...> using the handlers below
//
// connecting is all reads need. views ask for the EIP-712 login signature (signLogin) only right
// before a mint, since the mint contracts verify it on chain
export default {
  components: {
    WalletPicker
  },
  data () {
    return {
      walletChoices: [],
      resolveWalletChoice: undefined,
      walletConnectInProgress: false
    }
  },
  methods: {
    pickConnector () {
      const connectors = availableConnectors()
      if (connectors.length <= 1) {
        return Promise.resolve(connectors[0])
      }
      return new Promise((resolve) => {
        this.walletChoices = connectors
        this.resolveWalletChoice = resolve
      })
    },

    onWalletChosen (connector) {
      this.walletChoices = []
      this.resolveWalletChoice(connector)
    },

    onWalletPickerCancel () {
      this.walletChoices = []
      this.resolveWalletChoice(undefined)
    },

    // resolves the connected address, or undefined if no wallet / the user backed out of picking one /
    // a connect is already in progress (desktop icons fire both tap and dblclick)
    async connectWalletOnly () {
      if (this.walletConnectInProgress) { return }
      if (!hasWallet()) {
        window.alert('No web3 wallet found. Install one (e.g. MetaMask or Rabby) or open this site in your wallet app\'s browser.')
        return
      }

      this.walletConnectInProgress = true
      try {
        // already connected (e.g. connected on another page of the app) -> reuse that wallet
        let connector
        if (!isWalletConnected()) {
          connector = await this.pickConnector()
          if (!connector) { return }
        }
        return await connectWallet(connector)
      } finally {
        this.walletConnectInProgress = false
      }
    }
  }
}
